import maplibregl from 'maplibre-gl';
import { Protocol } from 'pmtiles';

let registered = false;

/** Register the pmtiles:// URL protocol with MapLibre. Idempotent. */
export function registerPmtilesProtocol() {
  if (registered) return;
  const protocol = new Protocol();
  maplibregl.addProtocol('pmtiles', protocol.tile);
  registered = true;
}
